import React from "react";
import { string } from "prop-types";
import DefaultMobileLogo from "../../icons/default-mobile-logo";
// import KiaLogo from "../../icons/kia-logo";

const MobileLogo = () => {
  return <DefaultMobileLogo width={165} height={38} />;
};

MobileLogo.propTypes = {
  domainSlug: string
};

export default MobileLogo;
